import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Globals } from '../../globals';
import { Timezone } from './timezones.interfaces';

@Injectable({
  providedIn: 'root',
})

/**
 * Timezone REST calls
 */
export class TimezonesService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);


  /**
   * Get all timezones
   */
  getTimezones(): Observable<Timezone[]> {
    const url = `${this.globals.apiRoot}/jwttimezones`;
    return this.http.get<Timezone[]>(url).pipe(timeout(1000));
  }
}
